import { CompanyInvitation, CompanyUser } from '__generated__/GQL';
import isEi from 'features/Onboarding/common/isEi';

import { VerificationStatus } from '../../Verification/lib/steps/types';

const getBeneficiariesModuleStatus = ({
  hasRegisteredAllBeneficiaries,
  isMainApplicant,
  legalBeneficiaries,
  legalForm,
}: {
  legalBeneficiaries: {
    invitation: Pick<CompanyInvitation, 'inviteeEmail'> | undefined | null;
    companyUser: Pick<CompanyUser, 'companyUserId'> | undefined | null;
    isCurrentUser: boolean;
  }[];
  hasRegisteredAllBeneficiaries: boolean;
  legalForm: string;
  isMainApplicant: boolean;
}): VerificationStatus => {
  if (isEi(legalForm) || !isMainApplicant) {
    return VerificationStatus.Irrelevant;
  }

  if (!hasRegisteredAllBeneficiaries) {
    return VerificationStatus.ToDo;
  }

  const isMissingSomeEmail = legalBeneficiaries.some(
    // If the account holder has been swapped with a legal beneficiary (via the BO),
    // then we can have a legal beneficiary without an invitation but with a companyUser
    ({ companyUser, invitation }) => !invitation?.inviteeEmail && !companyUser,
  );

  if (isMissingSomeEmail) {
    return VerificationStatus.Invalid;
  }

  return VerificationStatus.Completed;
};

export default getBeneficiariesModuleStatus;
